import { page, shows, type FeatureRoutes } from "@/app/feature";

export const routes: FeatureRoutes = {
  shell: [
    { path: "today", lazy: page(() => import("./TodayPage")), handle: shows("progression") },
    { path: "leagues", lazy: page(() => import("./LeaguesPage")), handle: shows("leagues") },
    // Dev only: the chest opening with a chosen content. Dropped from production builds.
    ...(import.meta.env.DEV ? [{ path: "dev/chest", lazy: page(() => import("./ChestLab")) }] : []),
  ],
};
